export enum SurveyQuestionnaireModality {
    Master = 0,
    Online = 1,
    Phone = 2,
}
